import { type ForwardedRef, forwardRef } from 'react';
import { IconComponent } from '@/components/IconComponent';
import { ScInfoBtn, type ScInfoBtnProps } from './styled';

interface InfoButtonProps extends ScInfoBtnProps {
  handleClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export const InfoButton = forwardRef<HTMLDivElement, InfoButtonProps>(
  ({ handleClick, gray, ...props }, ref: ForwardedRef<HTMLDivElement>) => (
    <ScInfoBtn gray={gray} onClick={handleClick} ref={ref} {...props}>
      <IconComponent name="tooltipIcon" />
    </ScInfoBtn>
  )
);
